// extracted by mini-css-extract-plugin
module.exports = {"notification":"NSpRed","notificationViewport":"QuOnRX"};